var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * Hook for `POST /czna-authorities/module-settings/{key}/validate`
 * (TASK-176). Debounced (500 ms) live validation called from the Settings
 * editor as the admin types in the textarea.
 *
 * Strategy:
 * 1. Local `JSON.parse(jsonText)` first — if it throws, surface
 *    `localParseError` without firing any network call.
 * 2. On valid local JSON, fire the POST. On HTTP 200 → `data = { valid:
 *    true, errors: [] }`. On HTTP 400 the backend returns
 *    `FormConfigValidationResult` with `valid: false` + structured
 *    errors — we transform 400 into success `data` so the UI can render
 *    one branch ("data.valid ? OK : show errors") rather than juggling
 *    error vs. success state.
 * 3. On 5xx / network the hook leaves `data = null` and surfaces
 *    `serverError = true` for a generic "validation service unavailable"
 *    hint.
 *
 * Debounce pattern: inline `useEffect` + `setTimeout` (500 ms), matching
 * `routes/AuthoritiesList.tsx:60-65`. No `lodash.debounce` or new dep.
 *
 * MEMORY rule: `useOkapiKy()` returns an unstable reference — captured in
 * the mutation closure, never listed in a hook dep array.
 */
import { useEffect, useState } from 'react';
import { useOkapiKy } from '@folio/stripes/core';
import { useMutation } from 'react-query';
var DEBOUNCE_MS = 500;
var ValidateServerError = /** @class */ (function (_super) {
    __extends(ValidateServerError, _super);
    function ValidateServerError(cause) {
        var _this = _super.call(this, 'useValidateFormConfig: validation service unavailable') || this;
        _this.serverError = true;
        _this.name = 'ValidateServerError';
        if (cause !== undefined) {
            _this.cause = cause;
        }
        return _this;
    }
    return ValidateServerError;
}(Error));
/**
 * Translate a `JSON.parse` SyntaxError into (line, col, message). V8's
 * SyntaxError message is e.g. "Unexpected token X in JSON at position 42";
 * we extract the position and count newlines to derive line/col.
 *
 * Exported for unit testing.
 */
export var parseSyntaxError = function (text, err) {
    var message = err instanceof Error ? err.message : 'Invalid JSON';
    var match = /position\s+(\d+)/i.exec(message);
    var pos = match ? Number(match[1]) : 0;
    var line = 1;
    var col = 1;
    for (var i = 0; i < pos && i < text.length; i += 1) {
        if (text[i] === '\n') {
            line += 1;
            col = 1;
        }
        else {
            col += 1;
        }
    }
    return { line: line, col: col, message: message };
};
var useValidateFormConfig = function (key, jsonText) {
    var _a;
    // Closure-capture only. MEMORY: ky is unstable — never in deps.
    var ky = useOkapiKy();
    var _b = useState(jsonText), debouncedText = _b[0], setDebouncedText = _b[1];
    // Debounce: 500 ms after the user stops typing.
    useEffect(function () {
        var timer = setTimeout(function () { return setDebouncedText(jsonText); }, DEBOUNCE_MS);
        return function () { return clearTimeout(timer); };
    }, [jsonText]);
    // Local parse check on the DEBOUNCED text — we don't want to flash
    // "Invalid JSON" while the user is still mid-keystroke.
    var localParseError = null;
    var parsedValue = null;
    var canValidate = false;
    if (debouncedText.trim() === '') {
        // Empty input — neither valid nor invalid; just nothing to validate.
        canValidate = false;
    }
    else {
        try {
            parsedValue = JSON.parse(debouncedText);
            canValidate = true;
        }
        catch (err) {
            localParseError = parseSyntaxError(debouncedText, err);
            canValidate = false;
        }
    }
    var mutation = useMutation(function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_1, status_1, body, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 7]);
                    return [4 /*yield*/, ky
                            .post("czna-authorities/module-settings/".concat(key, "/validate"), {
                            json: value,
                        })
                            .json()];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, response];
                case 2:
                    err_1 = _c.sent();
                    status_1 = (_b = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _b === void 0 ? void 0 : _b.status;
                    if (!(status_1 === 400 && err_1 && typeof err_1 === 'object' && 'response' in err_1)) return [3 /*break*/, 6];
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, err_1.response
                            .clone()
                            .json()];
                case 4:
                    body = _c.sent();
                    return [2 /*return*/, body];
                case 5:
                    _a = _c.sent();
                    return [3 /*break*/, 6];
                case 6: throw new ValidateServerError(err_1);
                case 7: return [2 /*return*/];
            }
        });
    }); });
    // Fire on each new debounced+parsed text. We compare against the last
    // text we sent so a duplicate (e.g. re-render with same string) doesn't
    // dispatch again. Capturing `parsedValue` in a state effect keeps the
    // mutate call out of render.
    useEffect(function () {
        if (!canValidate)
            return;
        mutation.mutate(parsedValue);
        // mutation.mutate is stable per react-query docs; parsedValue is
        // re-derived on each render so we depend on debouncedText instead.
        // IMPROVE-5: `key` is included defensively — if two record types
        // share identical default JSON and the caller swaps key without
        // text changing, the hook still re-validates against the right
        // endpoint.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedText, canValidate, key]);
    return {
        data: localParseError ? null : (_a = mutation.data) !== null && _a !== void 0 ? _a : null,
        localParseError: localParseError,
        isValidating: mutation.isLoading,
        serverError: mutation.isError,
    };
};
export default useValidateFormConfig;
